import React from 'react';
import StudyFilesManager from '@/components/study-files-manager/StudyFilesManager';
import { Container } from '@/components/ui';
import { withPermissions } from '@/components/withPermissions';
import { PERMISSIONS } from '@/types/permissions';

const StudyFiles: React.FC = () => {
  return (
    <Container pt="2" pb="2" size="expand" className="study-files-page">
      <StudyFilesManager />
    </Container>
  );
};

export const StudyFilesPage = withPermissions(StudyFiles, {
  requiredPermissions: [PERMISSIONS.STUDY_FILES_ACCESS],
  showRoleSwitcher: true,
});
